import MyPageModal from "../../../components/mypage/MyPageModal"
import { Button } from "../../../shadcn/Button"

type Props = {
  isOpen: boolean
  onClickEstimate: () => void
}

export const EstimateRestoreConfirmModal = ({ isOpen, onClickEstimate }: Props) => {
  return (
    <MyPageModal
      isOpen={isOpen}
      title="保存されていない見積があります"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
    >
      <div className="flex flex-col items-center gap-8 py-8">
        <p className="text-base leading-[1.5] text-gray-800">1-Click見積画面で内容を復元します</p>

        <div className="flex flex-col gap-4">
          <Button
            onClick={onClickEstimate}
            className="h-16 w-[360px] rounded-[32px] bg-[#16a34a] text-base font-semibold text-white hover:bg-[#15803d]"
          >
            1-Click見積へ進む
          </Button>
        </div>
      </div>
    </MyPageModal>
  )
}
